import React from "react";
import styles from "./TrustedPartners.module.css";
import { PARTNER_LOGOS } from "../assets";

export default function TrustedPartners() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.title}>
          <span className={styles.titleLight}>Trusted Partner for</span>
          <span className={styles.titleGradient}>250+ Metal Manufacturers</span>
        </h2>

        <ul className={styles.logos}>
          {PARTNER_LOGOS.map((logo) => (
            <li
              key={logo.name}
              className={`${styles.logoCard} ${
                logo.mobileFullWidth ? styles.logoCardWide : ""
              }`}
              style={{ "--logo-order": logo.mobileOrder }}
            >
              <img
                src={logo.src}
                alt={logo.name}
                className={styles.logo}
                loading="lazy"
                style={{
                  "--logo-w": logo.mobile?.width,
                  "--logo-h": logo.mobile?.height,
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
